"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityMapQuery = void 0;
var client_1 = require("@apollo/client");
var graphql_1 = require("./graphql");
var entityMapQuery = function (definition, context) {
  var _a = context.queryName,
    queryName = _a === void 0 ? '' : _a,
    _b = context.queryFields,
    queryFields = _b === void 0 ? '' : _b;
  var BODY = (0, graphql_1.graphql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query ", "($filter: ", "FilterInput) {\n    list", "(filter: $filter) @connection(key: \"map", "\") {\n      meta {\n        total\n        count\n      }\n      results {\n        id\n        slug\n        latitude\n        longitude\n        openGraph {\n          id\n          description { text(truncate: { words: 25 }) }\n          image { id url width height }\n        }\n        name\n        isActive\n        isDraft\n        isPublished\n        ", "\n      }\n    }\n  }"], ["query ", "($filter: ", "FilterInput) {\n    list", "(filter: $filter) @connection(key: \"map", "\") {\n      meta {\n        total\n        count\n      }\n      results {\n        id\n        slug\n        latitude\n        longitude\n        openGraph {\n          id\n          description { text(truncate: { words: 25 }) }\n          image { id url width height }\n        }\n        name\n        isActive\n        isDraft\n        isPublished\n        ", "\n      }\n    }\n  }"])), queryName || "".concat(definition.typeName, "Map"), definition.filterInputTypeName, definition.pluralTypeName, definition.pluralTypeName, queryFields || definition.map.queryFields || '');
  return !queryName && !queryFields && definition.map.query || (0, client_1.gql)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), BODY);
};
exports.entityMapQuery = entityMapQuery;
var templateObject_1, templateObject_2;